// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Navbar Styles */

/* Project Selector Styles */
.navbar-project-selector {
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
}

.navbar-project-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.6rem;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  font-size: 0.75rem;
  color: #1a202c;
  cursor: pointer;
  transition: all 0.2s ease;
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.navbar-project-button:hover {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
}

.navbar-project-readonly {
  cursor: default;
  pointer-events: none;
  max-width: 220px;
}

.navbar-project-readonly:hover {
  background-color: #f8fafc;
  border-color: #e2e8f0;
}

.navbar-project-readonly .navbar-project-text {
  display: inline;
  max-width: 180px;
}

.navbar-project-text {
  display: none;
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

@media (min-width: 768px) {
  .navbar-project-text {
    display: inline;
    max-width: 80px;
  }
}

.navbar-project-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 240px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
  z-index: 50;
  margin-top: 0.5rem;
  max-height: 400px;
  display: flex;
  flex-direction: column;
}

.project-dropdown-header {
  padding: 0.75rem;
  border-bottom: 1px solid #e2e8f0;
}

.project-search-input {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  transition: all 0.2s ease;
}

.project-search-input:focus {
  outline: none;
  border-color: #4361ee;
  box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.1);
}

.project-dropdown-content {
  flex: 1 1;
  overflow-y: auto;
  max-height: 320px;
}

.project-dropdown-loading,
.project-dropdown-error,
.project-dropdown-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  color: #718096;
  font-size: 0.875rem;
  gap: 0.5rem;
}

.project-dropdown-error {
  color: #dc2626;
}

.project-dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  background: none;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  color: #1a202c;
}

.project-dropdown-item:hover {
  background-color: #f8fafc;
}

.project-dropdown-item.selected {
  background-color: #eff6ff;
  border-left: 3px solid #4361ee;
  padding-left: calc(1rem - 3px);
}

.project-dropdown-item svg {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  color: #718096;
}

.project-dropdown-item.selected svg:first-child {
  color: #4361ee;
}

.project-item-content {
  flex: 1 1;
  min-width: 0;
}

.project-item-name {
  font-weight: 500;
  color: #1a202c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.875rem;
}

.project-item-type {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-dropdown-item.selected .project-item-name {
  color: #4361ee;
}

.project-dropdown-item svg:last-child {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  color: #4361ee;
}

/* Responsive Design */
@media (max-width: 768px) {
  .navbar-project-button {
    max-width: 50px;
    padding: 0.5rem;
  }

  .navbar-project-text {
    display: none;
  }

  .navbar-project-dropdown {
    width: 280px;
    left: -100px;
  }
}

/* Notification Styles */
.navbar-notification {
  position: relative;
  margin-right: 0.5rem;
  flex-shrink: 0;
}

.navbar-notification .notification-icon {
  cursor: pointer;
  padding: 6px;
  color: #718096;
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
}

.navbar-notification .notification-icon:hover {
  color: #4361ee;
}

.navbar-notification-badge {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #ef4444;
  color: white;
  border-radius: 9999px;
  padding: 0 5px;
  font-size: 0.75rem;
  font-weight: 600;
  min-width: 18px;
  height: 18px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #ffffff;
  line-height: 1;
  white-space: nowrap;
}

.notifications-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  width: 380px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  z-index: 50;
  max-height: 400px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
}

.notifications-header {
  padding: 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  background: white;
}

.notifications-list {
  overflow-x: hidden;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.notifications-title {
  font-weight: 600;
  color: #1a202c;
}

.notifications-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mark-all-read {
  color: #4361ee;
  font-size: 0.875rem;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.mark-all-read:hover {
  opacity: 0.8;
}

.notification-close-btn {
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #718096;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.notification-close-btn:hover {
  background-color: #f1f5f9;
  color: #4361ee;
}

.notification-close-btn svg {
  width: 16px;
  height: 16px;
}

.notification-item {
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.notification-item:hover {
  background-color: #f7fafc;
}

.notification-item.unread {
  background-color: #ebf4ff;
}

.notification-content {
  flex: 1 1;
  min-width: 0;
}

.notification-message {
  color: #4a5568;
  font-size: 0.875rem;
  line-height: 1.25rem;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.notification-time {
  color: #718096;
  font-size: 0.75rem;
  margin-top: 4px;
}

.notification-dot {
  width: 8px;
  height: 8px;
  background-color: #4361ee;
  border-radius: 50%;
  margin-top: 6px;
}

.empty-notifications {
  padding: 32px 16px;
  text-align: center;
  color: #718096;
}
:root {
  --primary-color: #4285F4;
  --text-dark: #333;
  --text-muted: #666;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.25rem 2rem;
  background: linear-gradient(90deg, var(--primary-color) 0%, #4285F4 100%);
  color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  min-height: 64px;
  transition: all 0.3s ease;
  flex-wrap: nowrap;
}

.navbar.scrolled {
  padding: 0.5rem 1rem;
  background: rgba(66, 133, 244, 0.95);
  backdrop-filter: blur(10px);
}

.navbar-brand {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  text-decoration: none;
  color: white;
  flex-shrink: 0;
}

.navbar-logo {
  width: 32px;
  height: 32px;
  transition: transform 0.3s ease;
}

.navbar-brand:hover .navbar-logo {
  transform: rotate(10deg);
}

.navbar-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
  letter-spacing: 0.5px;
  word-spacing: 4px;
}

.navbar-menu {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1 1;
  justify-content: space-between;
  min-width: 0;
  margin: 0 1rem;
}

.navbar-links {
  display: flex;
  gap: 1.2rem;
  margin: 0;
  padding: 0;
  list-style: none;
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb) transparent;
  width: 100%;
  justify-content: flex-start;
}

.navbar-links::-webkit-scrollbar {
  height: 6px;
}

.navbar-links::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: 4px;
}

.navbar-link {
  position: relative;
  color: white;
  text-decoration: none;
  font-weight: 500;
  padding: 0.5rem 0;
  transition: all 0.3s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.875rem;
}

.navbar-link::after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: white;
  transition: width 0.3s ease;
}

.navbar-link:hover::after,
.navbar-link.active::after {
  width: 100%;
}

.navbar-link.active {
  font-weight: 600;
}

.navbar-icon {
  flex-shrink: 0;
}

.navbar-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-left: auto;
  flex-shrink: 0;
}

.navbar-search {
  position: relative;
  width: 200px;
  transition: width 0.3s ease;
}

.navbar-search:focus-within {
  width: 250px;
}

.navbar-search input {
  width: 100%;
  padding: 0.5rem 0.75rem 0.5rem 2.25rem;
  border: none;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.navbar-search input::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.navbar-search input:focus {
  outline: none;
  background-color: rgba(255, 255, 255, 0.3);
}

.navbar-search-icon {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: white;
  pointer-events: none;
}

.navbar-button {
  background-color: transparent;
  border: 1px solid white;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.navbar-button:hover {
  background-color: white;
  color: var(--primary-color);
}

.navbar-button.primary {
  display: flex;
  align-items: center;
  background-color: white;
  color: var(--primary-color);
}

.navbar-button.primary:hover {
  background-color: rgba(255, 255, 255, 0.9);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.navbar-button.secondary {
  background-color: var(--secondary-color, #6c757d);
  color: white;
  border: 1px solid var(--secondary-color, #6c757d);
}

.navbar-button.secondary:hover {
  background-color: var(--secondary-color-dark, #545b62);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.navbar-button svg {
  margin-right: 0.5rem;
  vertical-align: middle;
}

/* Create Project Button */
.create-project-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  margin-right: 0.5rem;
  font-weight: 500;
  border-radius: 20px;
  transition: all 0.3s ease;
}

.create-project-icon {
  transition: transform 0.3s ease;
}

.create-project-btn:hover .create-project-icon {
  transform: rotate(90deg);
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  z-index: 2001;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.modal-header h2 {
  margin: 0;
  font-size: 1.35rem;
  color: var(--text-dark);
}

.modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-muted);
  transition: color 0.3s ease;
  padding: 0.25rem;
}

.modal-close:hover {
  color: var(--text-dark);
}

.modal-body {
  padding: 1.25rem;
  overflow-y: auto;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1.25rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

/* Form Styles for Create Project Modal */
.create-project-form .form-group {
  margin-bottom: 1.25rem;
}

.create-project-form label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--text-dark);
}

.create-project-form .form-input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  font-size: 0.9rem;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  box-sizing: border-box;
}

.create-project-form .form-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.2);
}

.create-project-form .checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.create-project-form .checkbox-label {
  display: grid;
  grid-template-columns: 24px 1fr;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
}

.create-project-form .checkbox-label input {
  margin: 0;
  width: auto;
  justify-self: center;
}

.create-project-form .checkbox-label span {
  font-weight: normal;
}

.navbar-user {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  position: relative;
  padding: 0.25rem;
  border-radius: 4px;
  transition: background-color 0.3s ease;
  flex-shrink: 0;
}

.navbar-user:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.navbar-user-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.75rem;
  transition: all 0.3s ease;
  flex-shrink: 0;
  overflow: hidden;
}

.navbar-user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.navbar-avatar-placeholder-icon {
  width: 20px;
  height: 20px;
  opacity: 0.8;
}

.navbar-user:hover .navbar-user-avatar {
  background-color: rgba(255, 255, 255, 0.3);
}

.navbar-user-name {
  font-weight: 500;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100px;
}

.navbar-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.5rem;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 240px;
  max-width: 320px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s ease;
  z-index: 1001;
  overflow: hidden;
}

.navbar-dropdown.open {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.navbar-dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  color: var(--text-dark);
  text-decoration: none;
  transition: all 0.2s ease;
  font-size: 0.9rem;
}

.navbar-dropdown-item:hover {
  background-color: rgba(66, 133, 244, 0.1);
}

.navbar-dropdown-divider {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  margin: 0.25rem 0;
}

/* Workspace Dropdown Styles */
.workspace-dropdown-section {
  position: relative;
}

.workspace-section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 1rem;
  color: var(--text-dark);
  background: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
  font-weight: 500;
  text-align: left;
}

.workspace-section-title:hover {
  background-color: rgba(66, 133, 244, 0.1);
}

.workspace-section-title svg:first-child {
  flex-shrink: 0;
  color: var(--primary, #007bff);
}

.workspace-section-title span {
  flex: 1 1;
}

.workspace-section-title svg:last-child {
  flex-shrink: 0;
  color: var(--text-muted, #666);
}

.workspace-submenu {
  padding: 0.25rem;
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 0.375rem;
  margin: 0 0.5rem;
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.workspace-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.workspace-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  color: var(--text-dark);
  background: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.85rem;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.workspace-item:hover {
  background-color: rgba(66, 133, 244, 0.15);
  color: var(--primary, #007bff);
}

.workspace-item svg {
  flex-shrink: 0;
  color: var(--primary, #007bff);
}

.workspace-divider {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  margin: 0.25rem 0;
}

.all-workspaces-link {
  font-weight: 500;
  color: var(--primary, #007bff);
}

.all-workspaces-link:hover {
  background-color: rgba(66, 133, 244, 0.2);
}

.workspace-loading,
.workspace-empty {
  padding: 0.5rem 0.75rem;
  text-align: center;
  color: var(--text-muted, #666);
  font-size: 0.85rem;
}

.navbar-mobile-toggle {
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.navbar-mobile-toggle:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.navbar-notification {
  position: relative;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.navbar-notification:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.navbar-notification-badge {
  top: 2px;
  right: 2px;
  background-color: #ff4757;
  font-size: 0.7rem;
}

.navbar-close {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-dark);
  padding: 0.25rem;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.navbar-close:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

/* Button Styles */
.btn {
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid transparent;
  font-size: 0.9rem;
}

.btn-primary {
  background-color: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}

.btn-primary:hover:not(:disabled) {
  background-color: #3367d6;
  border-color: #3367d6;
}

.btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-outline {
  background-color: transparent;
  color: var(--text-dark);
  border-color: rgba(0, 0, 0, 0.2);
}

.btn-outline:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

/* Overlay for mobile menu */
.navbar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 1001;
}

.navbar-overlay.open {
  visibility: visible;
}

/* Responsive styles */
@media (max-width: 1200px) {
  .navbar {
    padding: 0.25rem 1.2rem;
  }
  
  .navbar-menu {
    gap: 0.8rem;
    margin: 0 0.8rem;
  }
  
  .navbar-links {
    gap: 1rem;
  }
  
  .navbar-search {
    width: 150px;
  }
  
  .navbar-search:focus-within {
    width: 200px;
  }
  
  .navbar-link {
    font-size: 0.8rem;
  }
}

@media (max-width: 992px) {
  .navbar {
    padding: 0.25rem 0.8rem;
  }
  
  .navbar-brand {
    gap: 0.5rem;
  }
  
  .navbar-menu {
    gap: 0.6rem;
    margin: 0 0.6rem;
  }
  
  .navbar-links {
    gap: 0.8rem;
  }
  
  .navbar-link {
    font-size: 0.75rem;
    padding: 0.25rem 0;
  }
  
  .navbar-actions {
    gap: 0.5rem;
  }
  
  .navbar-project-button {
    font-size: 0.7rem;
    padding: 0.3rem 0.5rem;
    max-width: 80px;
  }

  .navbar-project-button.navbar-project-readonly {
    max-width: 180px;
  }

  .navbar-project-readonly .navbar-project-text {
    max-width: 140px;
  }
  
  .navbar-search {
    width: 120px;
  }
  
  .navbar-project-selector {
    margin-right: 0.3rem;
  }
  
  .navbar-notification {
    margin-right: 0.3rem;
  }
}

@media (max-width: 768px) {
  .navbar {
    padding: 0.25rem 0.5rem;
  }
  
  .navbar-title {
    font-size: 0.9rem;
  }
  
  .navbar-menu {
    gap: 0.4rem;
    margin: 0 0.4rem;
  }
  
  .navbar-links {
    gap: 0.6rem;
  }
  
  .navbar-link {
    font-size: 0.7rem;
    padding: 0.25rem 0;
    gap: 0.2rem;
  }
  
  .navbar-link svg {
    width: 14px;
    height: 14px;
  }
  
  .create-project-btn {
    padding: 0.3rem 0.6rem;
    font-size: 0.75rem;
  }
  
  .navbar-button {
    padding: 0.3rem 0.6rem;
    font-size: 0.8rem;
  }
  
  .navbar-user-name {
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.85rem;
  }
  
  .navbar-user-avatar {
    width: 28px;
    height: 28px;
    font-size: 0.7rem;
  }
  
  .navbar-project-button {
    font-size: 0.65rem;
    padding: 0.25rem 0.4rem;
    max-width: 70px;
  }

  .navbar-project-button.navbar-project-readonly {
    max-width: 150px;
  }

  .navbar-project-readonly .navbar-project-text {
    display: inline;
    max-width: 110px;
  }
  
  .navbar-search {
    width: 100px;
  }
  
  .navbar-search:focus-within {
    width: 150px;
  }
}

@media (max-width: 480px) {
  .navbar {
    padding: 0.2rem 0.3rem;
  }
  
  .navbar-logo {
    width: 26px;
    height: 26px;
  }
  
  .navbar-title {
    display: none;
  }
  
  .navbar-menu {
    gap: 0.2rem;
    margin: 0 0.2rem;
  }
  
  .navbar-links {
    gap: 0.4rem;
  }
  
  .navbar-link {
    font-size: 0.65rem;
    padding: 0.2rem 0;
  }
  
  .navbar-link svg {
    width: 12px;
    height: 12px;
  }
  
  .navbar-search {
    width: 80px;
  }
  
  .navbar-search:focus-within {
    width: 120px;
  }
  
  .navbar-user-avatar {
    width: 26px;
    height: 26px;
    font-size: 0.65rem;
  }
  
  .navbar-project-button {
    font-size: 0.6rem;
    padding: 0.2rem 0.3rem;
    max-width: 60px;
  }
  
  .navbar-actions {
    gap: 0.3rem;
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .navbar-link::after {
    height: 3px;
  }
  
  .navbar-search input {
    border: 1px solid white;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .navbar,
  .navbar-logo,
  .navbar-link,
  .navbar-link::after,
  .navbar-button,
  .navbar-dropdown,
  .navbar-overlay,
  .modal,
  .btn {
    transition: none;
  }
  
  .create-project-icon {
    transition: none;
  }
  
  .navbar-button.primary:hover {
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/navbar.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,+CAA+C;EAC/C,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;AACF;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,+CAA+C;EAC/C,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,yEAAyE;EACzE,YAAY;EACZ,yCAAyC;EACzC,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,8BAA8B;EAC9B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mDAAmD;EACnD,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,iDAAiD;EACjD,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,sDAAsD;EACtD,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA,yCAAyC;AACzC;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,wDAAwD;EACxD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,2BAA2B;AAC3B;EACE;;;;;;;;;IASE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Modern Navbar Styles */\n\n/* Project Selector Styles */\n.navbar-project-selector {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-right: 0.5rem;\n}\n\n.navbar-project-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.4rem 0.6rem;\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.5rem;\n  font-size: 0.75rem;\n  color: #1a202c;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  max-width: 100px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.navbar-project-button:hover {\n  background-color: #f1f5f9;\n  border-color: #cbd5e1;\n}\n\n.navbar-project-readonly {\n  cursor: default;\n  pointer-events: none;\n  max-width: 220px;\n}\n\n.navbar-project-readonly:hover {\n  background-color: #f8fafc;\n  border-color: #e2e8f0;\n}\n\n.navbar-project-readonly .navbar-project-text {\n  display: inline;\n  max-width: 180px;\n}\n\n.navbar-project-text {\n  display: none;\n  font-weight: 500;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n@media (min-width: 768px) {\n  .navbar-project-text {\n    display: inline;\n    max-width: 80px;\n  }\n}\n\n.navbar-project-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 240px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.5rem;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);\n  z-index: 50;\n  margin-top: 0.5rem;\n  max-height: 400px;\n  display: flex;\n  flex-direction: column;\n}\n\n.project-dropdown-header {\n  padding: 0.75rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.project-search-input {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  transition: all 0.2s ease;\n}\n\n.project-search-input:focus {\n  outline: none;\n  border-color: #4361ee;\n  box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.1);\n}\n\n.project-dropdown-content {\n  flex: 1;\n  overflow-y: auto;\n  max-height: 320px;\n}\n\n.project-dropdown-loading,\n.project-dropdown-error,\n.project-dropdown-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 1rem;\n  color: #718096;\n  font-size: 0.875rem;\n  gap: 0.5rem;\n}\n\n.project-dropdown-error {\n  color: #dc2626;\n}\n\n.project-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: none;\n  background: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n  color: #1a202c;\n}\n\n.project-dropdown-item:hover {\n  background-color: #f8fafc;\n}\n\n.project-dropdown-item.selected {\n  background-color: #eff6ff;\n  border-left: 3px solid #4361ee;\n  padding-left: calc(1rem - 3px);\n}\n\n.project-dropdown-item svg {\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n  color: #718096;\n}\n\n.project-dropdown-item.selected svg:first-child {\n  color: #4361ee;\n}\n\n.project-item-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.project-item-name {\n  font-weight: 500;\n  color: #1a202c;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.875rem;\n}\n\n.project-item-type {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.project-dropdown-item.selected .project-item-name {\n  color: #4361ee;\n}\n\n.project-dropdown-item svg:last-child {\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n  color: #4361ee;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .navbar-project-button {\n    max-width: 50px;\n    padding: 0.5rem;\n  }\n\n  .navbar-project-text {\n    display: none;\n  }\n\n  .navbar-project-dropdown {\n    width: 280px;\n    left: -100px;\n  }\n}\n\n/* Notification Styles */\n.navbar-notification {\n  position: relative;\n  margin-right: 0.5rem;\n  flex-shrink: 0;\n}\n\n.navbar-notification .notification-icon {\n  cursor: pointer;\n  padding: 6px;\n  color: #718096;\n  transition: color 0.2s ease;\n  display: flex;\n  align-items: center;\n}\n\n.navbar-notification .notification-icon:hover {\n  color: #4361ee;\n}\n\n.navbar-notification-badge {\n  position: absolute;\n  top: 0;\n  right: 0;\n  background-color: #ef4444;\n  color: white;\n  border-radius: 9999px;\n  padding: 0 5px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  min-width: 18px;\n  height: 18px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid #ffffff;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.notifications-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  width: 380px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  z-index: 50;\n  max-height: 400px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  margin-top: 0.5rem;\n}\n\n.notifications-header {\n  padding: 16px;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n  background: white;\n}\n\n.notifications-list {\n  overflow-x: hidden;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.notifications-title {\n  font-weight: 600;\n  color: #1a202c;\n}\n\n.notifications-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.mark-all-read {\n  color: #4361ee;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n}\n\n.mark-all-read:hover {\n  opacity: 0.8;\n}\n\n.notification-close-btn {\n  background: none;\n  border: none;\n  padding: 4px;\n  cursor: pointer;\n  color: #718096;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.notification-close-btn:hover {\n  background-color: #f1f5f9;\n  color: #4361ee;\n}\n\n.notification-close-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.notification-item {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e2e8f0;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.notification-item:hover {\n  background-color: #f7fafc;\n}\n\n.notification-item.unread {\n  background-color: #ebf4ff;\n}\n\n.notification-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.notification-message {\n  color: #4a5568;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.notification-time {\n  color: #718096;\n  font-size: 0.75rem;\n  margin-top: 4px;\n}\n\n.notification-dot {\n  width: 8px;\n  height: 8px;\n  background-color: #4361ee;\n  border-radius: 50%;\n  margin-top: 6px;\n}\n\n.empty-notifications {\n  padding: 32px 16px;\n  text-align: center;\n  color: #718096;\n}\n:root {\n  --primary-color: #4285F4;\n  --text-dark: #333;\n  --text-muted: #666;\n}\n\n.navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.25rem 2rem;\n  background: linear-gradient(90deg, var(--primary-color) 0%, #4285F4 100%);\n  color: white;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 10000;\n  min-height: 64px;\n  transition: all 0.3s ease;\n  flex-wrap: nowrap;\n}\n\n.navbar.scrolled {\n  padding: 0.5rem 1rem;\n  background: rgba(66, 133, 244, 0.95);\n  backdrop-filter: blur(10px);\n}\n\n.navbar-brand {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  text-decoration: none;\n  color: white;\n  flex-shrink: 0;\n}\n\n.navbar-logo {\n  width: 32px;\n  height: 32px;\n  transition: transform 0.3s ease;\n}\n\n.navbar-brand:hover .navbar-logo {\n  transform: rotate(10deg);\n}\n\n.navbar-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0;\n  white-space: nowrap;\n  letter-spacing: 0.5px;\n  word-spacing: 4px;\n}\n\n.navbar-menu {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex: 1;\n  justify-content: space-between;\n  min-width: 0;\n  margin: 0 1rem;\n}\n\n.navbar-links {\n  display: flex;\n  gap: 1.2rem;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  scrollbar-width: thin;\n  scrollbar-color: var(--scrollbar-thumb) transparent;\n  width: 100%;\n  justify-content: flex-start;\n}\n\n.navbar-links::-webkit-scrollbar {\n  height: 6px;\n}\n\n.navbar-links::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb);\n  border-radius: 4px;\n}\n\n.navbar-link {\n  position: relative;\n  color: white;\n  text-decoration: none;\n  font-weight: 500;\n  padding: 0.5rem 0;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.875rem;\n}\n\n.navbar-link::after {\n  content: '';\n  position: absolute;\n  width: 0;\n  height: 2px;\n  bottom: 0;\n  left: 0;\n  background-color: white;\n  transition: width 0.3s ease;\n}\n\n.navbar-link:hover::after,\n.navbar-link.active::after {\n  width: 100%;\n}\n\n.navbar-link.active {\n  font-weight: 600;\n}\n\n.navbar-icon {\n  flex-shrink: 0;\n}\n\n.navbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.navbar-search {\n  position: relative;\n  width: 200px;\n  transition: width 0.3s ease;\n}\n\n.navbar-search:focus-within {\n  width: 250px;\n}\n\n.navbar-search input {\n  width: 100%;\n  padding: 0.5rem 0.75rem 0.5rem 2.25rem;\n  border: none;\n  border-radius: 20px;\n  background-color: rgba(255, 255, 255, 0.2);\n  color: white;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.navbar-search input::placeholder {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.navbar-search input:focus {\n  outline: none;\n  background-color: rgba(255, 255, 255, 0.3);\n}\n\n.navbar-search-icon {\n  position: absolute;\n  left: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: white;\n  pointer-events: none;\n}\n\n.navbar-button {\n  background-color: transparent;\n  border: 1px solid white;\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 20px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.navbar-button:hover {\n  background-color: white;\n  color: var(--primary-color);\n}\n\n.navbar-button.primary {\n  display: flex;\n  align-items: center;\n  background-color: white;\n  color: var(--primary-color);\n}\n\n.navbar-button.primary:hover {\n  background-color: rgba(255, 255, 255, 0.9);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.navbar-button.secondary {\n  background-color: var(--secondary-color, #6c757d);\n  color: white;\n  border: 1px solid var(--secondary-color, #6c757d);\n}\n\n.navbar-button.secondary:hover {\n  background-color: var(--secondary-color-dark, #545b62);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.navbar-button svg {\n  margin-right: 0.5rem;\n  vertical-align: middle;\n}\n\n/* Create Project Button */\n.create-project-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  margin-right: 0.5rem;\n  font-weight: 500;\n  border-radius: 20px;\n  transition: all 0.3s ease;\n}\n\n.create-project-icon {\n  transition: transform 0.3s ease;\n}\n\n.create-project-btn:hover .create-project-icon {\n  transform: rotate(90deg);\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal {\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  width: 90%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  z-index: 2001;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.25rem;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 1.35rem;\n  color: var(--text-dark);\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--text-muted);\n  transition: color 0.3s ease;\n  padding: 0.25rem;\n}\n\n.modal-close:hover {\n  color: var(--text-dark);\n}\n\n.modal-body {\n  padding: 1.25rem;\n  overflow-y: auto;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 1.25rem;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n/* Form Styles for Create Project Modal */\n.create-project-form .form-group {\n  margin-bottom: 1.25rem;\n}\n\n.create-project-form label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: var(--text-dark);\n}\n\n.create-project-form .form-input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 6px;\n  font-size: 0.9rem;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n  box-sizing: border-box;\n}\n\n.create-project-form .form-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.2);\n}\n\n.create-project-form .checkbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.create-project-form .checkbox-label {\n  display: grid;\n  grid-template-columns: 24px 1fr;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n}\n\n.create-project-form .checkbox-label input {\n  margin: 0;\n  width: auto;\n  justify-self: center;\n}\n\n.create-project-form .checkbox-label span {\n  font-weight: normal;\n}\n\n.navbar-user {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  position: relative;\n  padding: 0.25rem;\n  border-radius: 4px;\n  transition: background-color 0.3s ease;\n  flex-shrink: 0;\n}\n\n.navbar-user:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.navbar-user-avatar {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 0.75rem;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.navbar-user-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.navbar-avatar-placeholder-icon {\n  width: 20px;\n  height: 20px;\n  opacity: 0.8;\n}\n\n.navbar-user:hover .navbar-user-avatar {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n\n.navbar-user-name {\n  font-weight: 500;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 100px;\n}\n\n.navbar-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 0.5rem;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 240px;\n  max-width: 320px;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(10px);\n  transition: all 0.3s ease;\n  z-index: 1001;\n  overflow: hidden;\n}\n\n.navbar-dropdown.open {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.navbar-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  color: var(--text-dark);\n  text-decoration: none;\n  transition: all 0.2s ease;\n  font-size: 0.9rem;\n}\n\n.navbar-dropdown-item:hover {\n  background-color: rgba(66, 133, 244, 0.1);\n}\n\n.navbar-dropdown-divider {\n  height: 1px;\n  background-color: rgba(0, 0, 0, 0.1);\n  margin: 0.25rem 0;\n}\n\n/* Workspace Dropdown Styles */\n.workspace-dropdown-section {\n  position: relative;\n}\n\n.workspace-section-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  color: var(--text-dark);\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-align: left;\n}\n\n.workspace-section-title:hover {\n  background-color: rgba(66, 133, 244, 0.1);\n}\n\n.workspace-section-title svg:first-child {\n  flex-shrink: 0;\n  color: var(--primary, #007bff);\n}\n\n.workspace-section-title span {\n  flex: 1;\n}\n\n.workspace-section-title svg:last-child {\n  flex-shrink: 0;\n  color: var(--text-muted, #666);\n}\n\n.workspace-submenu {\n  padding: 0.25rem;\n  background-color: rgba(0, 0, 0, 0.02);\n  border-radius: 0.375rem;\n  margin: 0 0.5rem;\n  animation: slideDown 0.2s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.workspace-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.workspace-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  color: var(--text-dark);\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.85rem;\n  text-decoration: none;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.workspace-item:hover {\n  background-color: rgba(66, 133, 244, 0.15);\n  color: var(--primary, #007bff);\n}\n\n.workspace-item svg {\n  flex-shrink: 0;\n  color: var(--primary, #007bff);\n}\n\n.workspace-divider {\n  height: 1px;\n  background-color: rgba(0, 0, 0, 0.1);\n  margin: 0.25rem 0;\n}\n\n.all-workspaces-link {\n  font-weight: 500;\n  color: var(--primary, #007bff);\n}\n\n.all-workspaces-link:hover {\n  background-color: rgba(66, 133, 244, 0.2);\n}\n\n.workspace-loading,\n.workspace-empty {\n  padding: 0.5rem 0.75rem;\n  text-align: center;\n  color: var(--text-muted, #666);\n  font-size: 0.85rem;\n}\n\n.navbar-mobile-toggle {\n  display: none;\n  background: none;\n  border: none;\n  color: white;\n  font-size: 1.5rem;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 4px;\n  transition: background-color 0.3s ease;\n}\n\n.navbar-mobile-toggle:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.navbar-notification {\n  position: relative;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 4px;\n  transition: background-color 0.3s ease;\n}\n\n.navbar-notification:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.navbar-notification-badge {\n  top: 2px;\n  right: 2px;\n  background-color: #ff4757;\n  font-size: 0.7rem;\n}\n\n.navbar-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--text-dark);\n  padding: 0.25rem;\n  border-radius: 4px;\n  transition: background-color 0.3s ease;\n}\n\n.navbar-close:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n/* Button Styles */\n.btn {\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: 1px solid transparent;\n  font-size: 0.9rem;\n}\n\n.btn-primary {\n  background-color: var(--primary-color);\n  color: white;\n  border-color: var(--primary-color);\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: #3367d6;\n  border-color: #3367d6;\n}\n\n.btn-primary:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.btn-outline {\n  background-color: transparent;\n  color: var(--text-dark);\n  border-color: rgba(0, 0, 0, 0.2);\n}\n\n.btn-outline:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n/* Overlay for mobile menu */\n.navbar-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n  z-index: 1001;\n}\n\n.navbar-overlay.open {\n  visibility: visible;\n}\n\n/* Responsive styles */\n@media (max-width: 1200px) {\n  .navbar {\n    padding: 0.25rem 1.2rem;\n  }\n  \n  .navbar-menu {\n    gap: 0.8rem;\n    margin: 0 0.8rem;\n  }\n  \n  .navbar-links {\n    gap: 1rem;\n  }\n  \n  .navbar-search {\n    width: 150px;\n  }\n  \n  .navbar-search:focus-within {\n    width: 200px;\n  }\n  \n  .navbar-link {\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 992px) {\n  .navbar {\n    padding: 0.25rem 0.8rem;\n  }\n  \n  .navbar-brand {\n    gap: 0.5rem;\n  }\n  \n  .navbar-menu {\n    gap: 0.6rem;\n    margin: 0 0.6rem;\n  }\n  \n  .navbar-links {\n    gap: 0.8rem;\n  }\n  \n  .navbar-link {\n    font-size: 0.75rem;\n    padding: 0.25rem 0;\n  }\n  \n  .navbar-actions {\n    gap: 0.5rem;\n  }\n  \n  .navbar-project-button {\n    font-size: 0.7rem;\n    padding: 0.3rem 0.5rem;\n    max-width: 80px;\n  }\n\n  .navbar-project-button.navbar-project-readonly {\n    max-width: 180px;\n  }\n\n  .navbar-project-readonly .navbar-project-text {\n    max-width: 140px;\n  }\n  \n  .navbar-search {\n    width: 120px;\n  }\n  \n  .navbar-project-selector {\n    margin-right: 0.3rem;\n  }\n  \n  .navbar-notification {\n    margin-right: 0.3rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .navbar {\n    padding: 0.25rem 0.5rem;\n  }\n  \n  .navbar-title {\n    font-size: 0.9rem;\n  }\n  \n  .navbar-menu {\n    gap: 0.4rem;\n    margin: 0 0.4rem;\n  }\n  \n  .navbar-links {\n    gap: 0.6rem;\n  }\n  \n  .navbar-link {\n    font-size: 0.7rem;\n    padding: 0.25rem 0;\n    gap: 0.2rem;\n  }\n  \n  .navbar-link svg {\n    width: 14px;\n    height: 14px;\n  }\n  \n  .create-project-btn {\n    padding: 0.3rem 0.6rem;\n    font-size: 0.75rem;\n  }\n  \n  .navbar-button {\n    padding: 0.3rem 0.6rem;\n    font-size: 0.8rem;\n  }\n  \n  .navbar-user-name {\n    max-width: 80px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 0.85rem;\n  }\n  \n  .navbar-user-avatar {\n    width: 28px;\n    height: 28px;\n    font-size: 0.7rem;\n  }\n  \n  .navbar-project-button {\n    font-size: 0.65rem;\n    padding: 0.25rem 0.4rem;\n    max-width: 70px;\n  }\n\n  .navbar-project-button.navbar-project-readonly {\n    max-width: 150px;\n  }\n\n  .navbar-project-readonly .navbar-project-text {\n    display: inline;\n    max-width: 110px;\n  }\n  \n  .navbar-search {\n    width: 100px;\n  }\n  \n  .navbar-search:focus-within {\n    width: 150px;\n  }\n}\n\n@media (max-width: 480px) {\n  .navbar {\n    padding: 0.2rem 0.3rem;\n  }\n  \n  .navbar-logo {\n    width: 26px;\n    height: 26px;\n  }\n  \n  .navbar-title {\n    display: none;\n  }\n  \n  .navbar-menu {\n    gap: 0.2rem;\n    margin: 0 0.2rem;\n  }\n  \n  .navbar-links {\n    gap: 0.4rem;\n  }\n  \n  .navbar-link {\n    font-size: 0.65rem;\n    padding: 0.2rem 0;\n  }\n  \n  .navbar-link svg {\n    width: 12px;\n    height: 12px;\n  }\n  \n  .navbar-search {\n    width: 80px;\n  }\n  \n  .navbar-search:focus-within {\n    width: 120px;\n  }\n  \n  .navbar-user-avatar {\n    width: 26px;\n    height: 26px;\n    font-size: 0.65rem;\n  }\n  \n  .navbar-project-button {\n    font-size: 0.6rem;\n    padding: 0.2rem 0.3rem;\n    max-width: 60px;\n  }\n  \n  .navbar-actions {\n    gap: 0.3rem;\n  }\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n  .navbar-link::after {\n    height: 3px;\n  }\n  \n  .navbar-search input {\n    border: 1px solid white;\n  }\n}\n\n/* Reduced motion support */\n@media (prefers-reduced-motion: reduce) {\n  .navbar,\n  .navbar-logo,\n  .navbar-link,\n  .navbar-link::after,\n  .navbar-button,\n  .navbar-dropdown,\n  .navbar-overlay,\n  .modal,\n  .btn {\n    transition: none;\n  }\n  \n  .create-project-icon {\n    transition: none;\n  }\n  \n  .navbar-button.primary:hover {\n    transform: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
